export default __webpack_public_path__ + "static/media/c002-PPII-6.25ea343c.svg";